var render = function render(_c,_vm){return _c('div',{staticClass:"price"},[_c('div',{staticClass:"price_block",class:(_vm.props.product.warehousePromo && !_vm.props.useWpid) ||
      (_vm.props.product.warehousePromo &&
        _vm.props.useWpid &&
        _vm.props.useWpid !== '-1')
        ? _vm.props.product.warehousePromo.view.cssClass
        : ''},[(
        (_vm.props.product.priceStandardDisplay && !_vm.props.useWpid) ||
          (_vm.props.product.priceStandardDisplay &&
            _vm.props.useWpid &&
            _vm.props.useWpid !== '-1')
      )?_c('div',{staticClass:"old-price my-1"},[_c('span',[_vm._v(" Anzichè "+_vm._s(_vm.parent.$n(_vm.props.product.priceStandardDisplay, "currency")))]),_vm._v("   ")]):_vm._e(),(
        (_vm.props.product.priceDisplay && !_vm.props.useWpid) ||
          (_vm.props.product.priceDisplay &&
            _vm.props.useWpid &&
            _vm.props.useWpid !== '-1')
      )?_c('div',{staticClass:"cur-price",class:{
        'promo--text':
          (_vm.props.product.priceStandardDisplay && !_vm.props.useWpid) ||
          (_vm.props.product.priceStandardDisplay &&
            _vm.props.useWpid &&
            _vm.props.useWpid !== '-1')
      }},[_vm._v(" "+_vm._s(_vm.parent.$n(_vm.props.product.priceDisplay, "currency"))+" "),(_vm.props.product.productInfos.TIPOLOGIA != 'Pezzo')?_c('span',{staticClass:"weight-unit"},[_vm._v("/"+_vm._s(_vm.props.product.weightUnitDisplay)+" ")]):_vm._e()]):(
        _vm.props.product.priceDisplay && _vm.props.useWpid && _vm.props.useWpid === '-1'
      )?_c('div',{staticClass:"cur-price"},[_vm._v(" "+_vm._s(_vm.parent.$n(_vm.props.product.priceStandardDisplay, "currency"))+" "),(_vm.props.product.productInfos.TIPOLOGIA != 'Pezzo')?_c('span',{staticClass:"weight-unit"},[_vm._v("/"+_vm._s(_vm.props.product.weightUnitDisplay)+" ")]):_vm._e()]):_c('div',{staticClass:"cur-price"},[_vm._v("-")]),(
        (_vm.props.product.productInfos.TIPOLOGIA == 'Pezzo' &&
          _vm.props.product.priceUmDisplay &&
          !_vm.props.useWpid) ||
          (_vm.props.product.priceUmDisplay &&
            _vm.props.useWpid &&
            _vm.props.useWpid !== '-1')
      )?_c('div',{staticClass:"price-um"},[_c('span',[_vm._v(" ("+_vm._s(_vm.parent.$n(_vm.props.product.priceUmDisplay, "currency"))+" /"+_vm._s(_vm.props.product.weightUnitDisplay)+") ")]),_vm._v("   ")]):(
        _vm.props.product.productInfos.TIPOLOGIA == 'Pezzo' &&
          _vm.props.product.priceUmDisplay &&
          _vm.props.useWpid &&
          _vm.props.useWpid === '-1'
      )?_c('div',{staticClass:"price-um"},[_c('span',[_vm._v(" ("+_vm._s(_vm.parent.$n(_vm.props.product.priceStandardUmDisplay, "currency"))+" /"+_vm._s(_vm.props.product.weightUnitDisplay)+") ")]),_vm._v("   ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }